// /**
//  * Orders - list
//  */

// React
import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderBuilder from '../../utils/headerBuilder';
// Context
import AuthContext from '../../authContext';

// UI
import theme from '../../theme';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
  lighten,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
  Button,
  Checkbox,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Select,
  CircularProgress,
  Grid,
  Toolbar,
  Typography,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiFileDocumentOutline,
  mdiPackageVariantClosed,
  mdiPencilOutline,
  mdiPlusBoxMultipleOutline,
  mdiPlusBoxMultiple,
  mdiTruckOutline,
  mdiTruck,
  mdiInformation,
} from '@mdi/js';

// Components
import Can from '../../components/Can';
import clsx from 'clsx';
// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../utils/rulesOrderStatus';

// Helper
import { translate } from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { NonPostOrder } from './interfaces';
import List from './usersList';
import stableSort from '../../utils/Table/stableSort';
import getComparator from '../../utils/Table/getComparator';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';

type Data = NonPostOrder;
type Props = {
  data: any;
  loading: boolean;
  handleOpenChangeType: (id: number) => void;
  handleOpenChangeTransportationType: (id: number) => void;
  handleOpenConfirmUpdateState: (val: { id: number; body: string }) => void;
  handleSelectedList: (selected: Order[]) => void;
  handleSelectAllClick: (event: any) => void;

};
type Ord = 'asc' | 'desc';

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiTableCell-paddingCheckbox': {
        padding: '0 0 0 5px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px 0 0',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 650,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: 'space-between',
    },
    highlight:
      theme.palette.type === 'light'
        ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
    title: {
      // flex: '1 1 100%',
    },
  })
);

interface EnhancedTableToolbarProps {
  numSelected: number;
  setOpenChangeStatus: any;
  selected: any;
  data: any;
  handleNumSelect: number;
  changeStatusOrderWhitId: (T: any) => void;
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const classes = useToolbarStyles();
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const { numSelected, selected, data } = props;

  const handleClickChangeStatus = () => {
    const selectedData = data.filter(
      (item: any) => selected.indexOf(item.id) > -1
    );

    if (!checkStatus(selectedData)) {
      setOpenAlertWarning(true);
    } else {
      props.setOpenChangeStatus(true);
    }
  };

  const checkStatus = (data: any) => {
    let sameStatus = true;
    data?.map((item: any) => {
      if (item?.status !== data[0]?.status) {
        return (sameStatus = false);
      }
      return item;
    });
    return sameStatus;
  };

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              {numSelected} انتخاب
            </Typography>
          ) : (
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            />
          )}
          {/* {numSelected > 0 ? (
            <Tooltip title="تخصیص اپراتور">
              <Button
                size="small"
                variant="contained"
                onClick={handleClickChangeStatus}
                color="secondary"
              >
                تخصیص اپراتور
              </Button>
            </Tooltip>
          ) : (
            <></>
            // <Tooltip title="Filter list">
            //   <IconButton aria-label="filter list">
            //     FilterIcon
            //   </IconButton>
            // </Tooltip>
          )} */}
        </Toolbar>
      )}
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => {
          setOpenAlertWarning(false);
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد </DialogTitle>
        <DialogContent>
          وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {'متوجه شدم'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  const [selected, setSelected] = React.useState<string[]>([]);
  const [openChangeStatus, setOpenChangeStatus] = React.useState(false);
  const [selectedOperator, setSelectedOperator] = useState(0);
  const [tplStatuses, setTplStatuses] = useState([])

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectOperator = (event: { target: HTMLInputElement }) => {
    const { target } = event;
    setSelectedOperator(+target.value);
  };



  const changeStatusOrder = () => {
    props.changeStatusOrderWhitId({
      ids: selected,
      operatorId: selectedOperator,
      description: null,
    });
  };

  const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);

  useEffect(() => {
    let storedId = JSON.parse(localStorage.getItem('id'));
    if (storedId == null) {
      storedId = [];
    }
    setSelected(storedId);
    getOrderTplStatuses()
  }, [props.filterVal]);

  const isSelected = (id: string) => {
    return props.selectedItems?.indexOf(id) !== -1;
  };

  const getOrderTplStatuses = async () => {
    const ids = props?.data?.filter(el => {
      return !["SNAPP", "TAPSI"].includes(el.orderTPLType)
    }).map(el => {
      return el.id
    })
    try {
      const response = await ordersRepository.getOrderTPLStatus({ payload: { orderIds: ids } })
      setTplStatuses(response.data)
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div className={classes.root}>
      <EnhancedTableToolbar
        numSelected={props.selectedItems.length}
        setOpenChangeStatus={setOpenChangeStatus}
        selected={props.selectedItems}
        data={props.data}
      />
      <Paper className={classes.paper}>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
            aria-label="enhanced table"
          >
            <HeaderBuilder
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.data.length}
              numSelected={props.selectedItems.length}
              onSelectAllClick={props.selectAll}
              filterVal={props.filterVal}
              onFilterValue={(filtervalues: any) => {
                props.onFilterValue(filtervalues);
              }}
              head={props.head}
              checkbox={true}
              removeFilterHandler={props.removeFilterHandler}
              haveAction={true}
              filterLabelTranslator={props.filterLabelTranslator}
            />

            <TableBody>
              {stableSort(props.data, getComparator(order, orderBy))
                .slice()
                .map((row: any, index: number) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  let color = '';
                  let backgroundColor = '';
                  let bgColor = '';

                  switch (true) {
                    case row.status === 'UNLOADED' ||
                      row.status === 'PACKAGED' ||
                      row.status === 'BUNDLED' ||
                      row.status === 'ASSIGNED':
                      backgroundColor = '#d1e8fa';
                      color = '#283c74';
                      break;
                    case row.status === 'CANCELLED' ||
                      row.status === 'RETURNING':
                      backgroundColor = '#fdd1cc';
                      color = '#611a15';
                      break;
                    case row.status === 'LOADED' || row.status === 'DELIVERED':
                      backgroundColor = '#d7fcd7';
                      color = '#1e4659';
                      break;
                    case row.status === 'ORDERED' && !row.exists:
                      backgroundColor = '#f7d28b';
                      color = '#111111';
                      break;
                  }
                  switch (true) {
                    case row.customerCity !== 'تهران':
                      backgroundColor = '#ffffed';
                      break;
                  }

                  return (
                    <TableRow
                      key={index}
                      hover
                      role="checkbox"
                      style={{ backgroundColor: backgroundColor }}
                      aria-checked={isSelected(row.id)}
                      tabIndex={-1}
                      selected={isSelected(row.id)}
                    >
                      <StyledTableCell padding="checkbox">
                        <Can
                          role={authContext.user.role}
                          perform="orders:changeOrderStatus"
                          yes={() => (
                            <Checkbox
                              key={index}
                              onClick={event =>
                                props.handleSelect(row.id, row.status)
                              }
                              checked={isSelected(row.id)}
                              inputProps={{ 'aria-labelledby': labelId }}
                            />
                          )}
                        />
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                        data-cy="row-id"
                      >
                        <HtmlTooltip
                          title={
                            row?.customerAddress + ' __ ' + row?.customerName
                          }
                        >
                          <span>
                            {`${row.customerCity
                              }-${row?.customerAddress?.substring(0, 20)}`}
                          </span>
                        </HtmlTooltip>
                      </StyledTableCell>
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{ color: color, backgroundColor: bgColor }}
                      >
                        {row.id}
                        {row.description && <HtmlTooltip title={row.description}>
                          <Icon path={mdiInformation} size={0.8}/>
                        </HtmlTooltip>}
                      </StyledTableCell>
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{
                          color: color,
                          backgroundColor: bgColor,
                          direction: 'ltr',
                        }}
                      >
                        {row?.fulfillmentWarehouseName
                          ? row?.fulfillmentWarehouseName
                          : row?.centerName}
                      </StyledTableCell>
                      <StyledTableCell
                        scope="row"
                        align="center"
                        style={{ backgroundColor: bgColor }}
                      >
                        {row.partnerName}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          color: color,
                          direction: 'ltr',
                          backgroundColor: bgColor,
                        }}
                      >
                        <span>
                          {jMoment(row.deliveryDate, 'YYYY/M/D')
                            .locale('fa')
                            .format('jYY/jMM/jDD')}
                        </span>
                        {'  '}
                        <span style={{ padding: '0 5px' }}>
                          {`${jMoment(row.deliveryStartTime, 'HH:mm:ss')
                            .locale('fa')
                            .format('HH:mm')}`}
                          {`- ${jMoment(row.deliveryEndTime, 'HH:mm:ss')
                            .locale('fa')
                            .format('HH:mm')}`}
                        </span>
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{
                          color: color,
                          direction: 'ltr',
                          backgroundColor: bgColor,
                        }}
                      >
                        {row.deliveryType == "CHAPAR" ? "چاپار" : !row.orderTPLType ? "پیک" : translate(row.orderTPLType, 'TPL')}
                      </StyledTableCell>
                      {/* <StyledTableCell
                        align="center"
                        style={{
                          color: color,
                          direction: 'ltr',
                          backgroundColor: bgColor,
                        }}
                      >
                        <span>
                          {row.packagedDate
                            ? jMoment(row.packagedDate, 'YYYY/M/D HH:mm:ss.SSZ')
                              .locale('fa')
                              .format('jYY/jMM/jDD HH:mm:ss')
                            : '-'}
                        </span>
                      </StyledTableCell> */}
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{ color: color, backgroundColor: bgColor }}
                      >
                        {row.weight}
                      </StyledTableCell>
                      <StyledTableCell
                        id={labelId}
                        scope="row"
                        align="center"
                        style={{
                          color: color,
                          direction: 'ltr',
                          backgroundColor: bgColor,
                        }}
                      >
                        {row.packages?.length > 1 ? (
                          <HtmlTooltip
                            title={
                              <React.Fragment>
                                {row.packages.map((itemPackage: any) => {
                                  return (
                                    <p style={{ color: color, direction: 'ltr' }}>
                                      {itemPackage.length} x {itemPackage.width}{' '}
                                      x {itemPackage.height}
                                    </p>
                                  );
                                })}
                              </React.Fragment>
                            }
                          >
                            <Button>
                              <Grid
                                style={{ flexWrap: 'nowrap' }}
                                container
                                alignItems="center"
                                spacing={2}
                              >
                                <span>
                                  {`${row.packages[0].length} x ${row.packages[0].width} x ${row.packages[0].height}`}
                                </span>
                                {row.packages.length > 1 && (
                                  <span style={{ padding: '5px' }}>
                                    <Icon
                                      color={theme.palette.green.main}
                                      path={mdiPlusBoxMultiple}
                                      size={1}
                                    />
                                  </span>
                                )}
                              </Grid>
                            </Button>
                          </HtmlTooltip>
                        ) : row.packages?.length === 1 ? (
                          <span>
                            {`${row.packages[0].length} x ${row.packages[0].width} x ${row.packages[0].height}`}
                          </span>
                        ) : (
                          '-'
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {translate(row.paymentType, 'cod')}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ color: color, backgroundColor: bgColor }}
                      >
                        {/*COMP MARK*/}
                        <Can
                          role={authContext.user.role}
                          perform="orders:changeOrderStatus"
                          yes={() => (
                            <FormControl style={{ width: '100%' }}>
                              <Icon
                                path={mdiPencilOutline}
                                size={1}
                                className={classes.changStatusIcon}
                              />
                              <Select
                                className={classes.changStatusBox}
                                fullWidth
                                name={`status${index}`}
                                multiple
                                id={row.id}
                                value={[{}]}
                                disabled={
                                  row.status === 'ORDERED' ||
                                  row.status === 'PICKED' ||
                                  row.status === 'ASSIGNED'
                                }
                                IconComponent={() => null}
                                renderValue={() => (
                                  <span className={classes.renderValue}>
                                    {translate(row.status, 'order')}
                                  </span>
                                )}
                              >
                                <RadioGroup
                                  className={classes.radioGroup}
                                  aria-label={`status${index}`}
                                  name={`status${index}`}
                                  value={'item'}
                                  onChange={(
                                    e: React.ChangeEvent<{ value: unknown }>
                                  ) =>
                                    props.handleOpenConfirmUpdateState({
                                      id: row.id,
                                      body: `${e.target.value}`,
                                    })
                                  }
                                >
                                  {rulesOrderStatus[row.status]?.map(
                                    (item: any, index: number) => (
                                      <FormControlLabel
                                        className={classes.radioGroupItem}
                                        key={index}
                                        checked={row.status === item}
                                        value={item}
                                        disabled={
                                          rulesAdminChangeOrderStatus[
                                            authContext.user.role
                                          ].indexOf(item) === -1
                                        }
                                        control={<Radio />}
                                        label={translate(item, 'order')}
                                      />
                                    )
                                  )}
                                </RadioGroup>
                              </Select>
                            </FormControl>
                          )}
                          no={() => {
                            return (
                              <span>{translate(row.status, 'order')}</span>
                            );
                          }}
                        />
                      </StyledTableCell>
                      <StyledTableCell
                        align="right"
                        style={{ backgroundColor: bgColor }}
                      >
                        <div>
                          <IconButton
                            aria-label="changeAction"
                            size="small"
                            title="نوع ارسال سفارش"
                            data-cy="changeAction"
                            onClick={() =>
                              props.handleOpenChangeTransportationType([row.id])
                            }
                          >
                            {(!tplStatuses.includes(row.id) && !["SNAPP", "TAPSI"].includes(row.orderTPLType)) ? (
                              <Icon
                                path={
                                  !row.orderTPLType ? mdiTruckOutline : mdiTruck
                                }
                                color={!row.bundleId && theme.palette.gray.main}
                                size={1}
                              />
                            ) : (
                              <img
                                style={{ width: '30px', objectFit: 'contain' }}
                                src={
                                  `/${row.orderTPLType}.png`
                                }
                                alt={row.orderTPLType}
                              />
                              // ) : (
                              //   <Icon
                              //     path={
                              //       !row.orderTPLType ? mdiTruckOutline : mdiTruck
                              //     }
                              //     color={!row.bundleId && theme.palette.gray.main}
                              //     size={1}
                              //   />
                              // )
                            )}
                            {/* KEEP the lines below */}
                            {/* {(!row.orderTPLType ||
                              row.orderTPLType === 'RONAD') && (
                                row.deliveryType === 'CHAPAR' ? (
                                  <img
                                    style={{ width: '30px', objectFit: 'contain' }}
                                    src={'/chaparB.png'}
                                    alt={row.orderTPLType}
                                  />
                                ) : (
                                  <Icon
                                    path={
                                      !row.orderTPLType ? mdiTruckOutline : mdiTruck
                                    }
                                    color={!row.bundleId && theme.palette.gray.main}
                                    size={1}
                                  />
                                ))}
                            {row.orderTPLType &&
                              row.orderTPLType !== 'RONAD' && (
                                <img
                                  style={{ width: '30px', objectFit: 'contain' }}
                                  src={
                                    row.deliveryType === 'CHAPAR'
                                      ? '/chaparB.png'
                                      : row.orderTPLType === 'ALOPEYK'
                                        ? '/ALOPEYK.png'
                                        : row.orderTPLType === 'TAROFF'
                                          ? '/TAROFF.png'
                                          : row.orderTPLType === 'LINK_EXPRESS'
                                            ? '/LINK_EXPRESS.png'
                                            : row.orderTPLType === 'CHAPAR'
                                              ? '/CHAPAR.png'
                                              : row.orderTPLType === 'SPEED'
                                                ? '/SPEED.png'
                                                : row.orderTPLType === 'PETROEX'
                                                  ? '/PETROEX.png'
                                                  : row.orderTPLType === 'PISHRO_POST'
                                                    ? '/PISHRO_POST.png'
                                                    : row.orderTPLType === 'TAPIN_POST'
                                                      ? '/TAPIN_POST.svg'
                                                      : row.orderTPLType === 'DTSXP'
                                                        ? '/DTSXP.png'
                                                        : row.orderTPLType === 'NEDEX'
                                                          ? '/NEDEX.png'
                                                          : row.ordeTPLType === 'TAPIN_KETAB'
                                                            ? '/TAPIN_KETAB.svg'
                                                            : ''
                                  }
                                  alt={row.orderTPLType}
                                />
                              )} */}
                          </IconButton>
                          {!row.orderTPLType && (
                            <Link to={`/nonPost-orders/${row.id}`}>
                              <IconButton
                                aria-label="details"
                                size="small"
                                title="جزئیات سفارش"
                                data-cy="details"
                              >
                                <Icon
                                  path={mdiFileDocumentOutline}
                                  size={1}
                                  color={theme.palette.green.main}
                                />
                              </IconButton>
                            </Link>
                          )}
                          {row.orderTPLType && (
                            <Link to={`/nonPost-orders/3pl-orders/${row.id}`}>
                              <IconButton
                                aria-label="details"
                                size="small"
                                title="جزئیات سفارش 3PL"
                                data-cy="details"
                              >
                                <Icon
                                  path={mdiFileDocumentOutline}
                                  size={1}
                                  color={theme.palette.green.main}
                                />
                              </IconButton>
                            </Link>
                          )}
                          {/* {row.deliveryLocationType !== "IN_RONAD" &&
                            <IconButton
                              aria-label="changeAction"
                              size="small"
                              title="تغییر نوع ارسال سفارش"
                              data-cy="changeAction"
                              onClick={() => props.handleOpenChangeType([row.id])}
                            >
                              <Icon
                                path={mdiPlusBoxMultipleOutline}
                                size={1}
                                color={theme.palette.orange.main}
                              />
                            </IconButton>
                          } */}
                          <Can
                            role={authContext.user.role}
                            perform="orders:byBundle"
                            yes={() =>
                              (row.status === 'BUNDLED' ||
                                row.status === 'DELIVERED' ||
                                row.status === 'LOADED' ||
                                row.status === 'ARRIVED') &&
                                row.status &&
                                row.bundleId ? (
                                <Link to={`/bundles/${row.bundleId}`}>
                                  <IconButton
                                    aria-label="bundle"
                                    size="small"
                                    title="نمایش سفارش در بسته "
                                    color="secondary"
                                  >
                                    <Icon
                                      path={mdiPackageVariantClosed}
                                      size={1}
                                      color={theme.palette.blue.main}
                                    />
                                  </IconButton>
                                </Link>
                              ) : (
                                <IconButton
                                  aria-label="bundle"
                                  size="small"
                                  title="بسته‌بندی نشده"
                                  disabled
                                  color="default"
                                  style={{ pointerEvents: 'fill' }}
                                >
                                  <Icon
                                    path={mdiPackageVariantClosed}
                                    size={1}
                                  />
                                </IconButton>
                              )
                            }
                          />
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Dialog
        fullWidth
        open={openChangeStatus}
        onClose={() => setOpenChangeStatus(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {'تغییر وضعیت کلی سفارش ها به تخصیص داده شده'}
        </DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">
              {'اپراتور مورد نظر را انتخاب کنید'}
            </FormLabel>
            <Grid
              container
              xs={12}
              style={{ marginTop: '20px', marginRight: 0, marginLeft: 0 }}
            >
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <List
                  onSelectOperator={handleSelectOperator}
                  selectedOperator={selectedOperator}
                  data={props.users}
                />
              )}
            </Grid>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenChangeStatus(false)}
            variant="contained"
            color="primary"
          >
            {'خیر'}
          </Button>

          <Button
            onClick={changeStatusOrder}
            color="primary"
            variant="outlined"
            disabled={!selectedOperator}
          >
            {'تخصیص اپراتور'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
